import React from 'react'

import TabelaSimcardsVirgensSolicitacoes from '../../../components/SimcardsVirgens/Solicitacoes/index'

export default function simCardsVirgens() {
  return (
    <div>
      <TabelaSimcardsVirgensSolicitacoes />
    </div>
  )
}
